export default "/static/explore/52637a98b6af851089caccbad8aa8eb115d3d065/_next/static/images/reminders-hearts-bg-844ed728d9bdf2b82e3ad2c9208c4cb2.jpg";